import { memo, useCallback } from "react"
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import SwalMessage from "../../_Components/SwalMessage";
import CloseIcon from "@mui/icons-material/Close";

const CopyDescription = ({
  reserveFormCopyModal,
  setReserveFormCopyModal,
  reserveItemGroups,
  reserveItems,
  dates
}) => {
  const methods = useFormContext()

  const onSubmitCopy = useCallback(async (data) => {
    const copyDates = new Set();
    dates.map(function (date) {
      if (data["CopyTo-" + date.nameDate]) {
        copyDates.add(date);
      }
    });
    [...copyDates].map(function ({ nameDate }) {
      methods.setValue(`${nameDate}-IA`, data[`${reserveFormCopyModal.currentDate}-IA`]);
      methods.setValue(`${nameDate}-Des`, data[`${reserveFormCopyModal.currentDate}-Des`]);
      reserveItemGroups.map(function (group) {
        methods.setValue(`${nameDate}-${group.id}-ID`, data[`${reserveFormCopyModal.currentDate}-${group.id}-ID`]);
        methods.setValue(`${nameDate}-${group.id}-IA`, data[`${reserveFormCopyModal.currentDate}-${group.id}-IA`]);
        methods.setValue(`${nameDate}-${group.id}-Des`, data[`${reserveFormCopyModal.currentDate}-${group.id}-Des`]);
        reserveItems.map(function (item) {
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-ID`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-ID`],
          );
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-IA`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-IA`],
          );
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-C`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-C`],
          );
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-IDL`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-IDL`],
          );
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-IFC`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-IFC`],
          );
          methods.setValue(
            `${nameDate}-${group.id}-${item.id}-MinC`,
            data[`${reserveFormCopyModal.currentDate}-${group.id}-${item.id}-MinC`],
          );
        });
      });
    });
    SwalMessage({
      title: "تغییرات اعمال گردید",
      iSsuccess: true,
    });
  }, [dates, reserveFormCopyModal]);

  return (
    <Modal
      show={reserveFormCopyModal.isShow}
      onHide={() => {
        setReserveFormCopyModal({ ...reserveFormCopyModal, isShow: false });
      }}
      animation={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>کپی کردن خصوصیات</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmitCopy)}>
          <Row>
            <Col xs="12">
              <Button
                variant="secondary"
                type="button"
                className="mr-2"
                onClick={(e) => {
                  setReserveFormCopyModal({ ...reserveFormCopyModal, isShow: false });
                }}
              >
                بستن
            </Button>
              <Button type="submit" color="primary">
                کپی
            </Button>
            </Col>

            <Col xs="12" className="py-4  border rounded-3 my-4 d-flex align-items-center flex-wrap">
              <div>
                <Controller
                  name="CopyTo-CheckedSat"
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "شنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              شنبه
              {"   -   "}
              </div>
              <div>
                <Controller
                  name={`CopyTo-CheckedSun`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "یکشنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              یکشنبه
              {"   -   "}
              </div>
              <div>
                <Controller
                  name={`CopyTo-CheckedMon`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "دوشنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              دوشنبه
              {"   -   "}
              </div>
              <div>
                <Controller
                  name={`CopyTo-CheckedTus`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "سه شنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              سه شنبه
              {"   -   "}
              </div>
              <div>
                <Controller
                  name={`CopyTo-CheckedWen`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "چهارشنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              چهارشنبه
              {"   -   "}
              </div>
              <div>
                {" "}
                <Controller
                  name={`CopyTo-CheckedThu`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "پنج شنبه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              پنج شنبه
              {"   -   "}
              </div>
              <div>
                <Controller
                  name={`CopyTo-CheckedFri`}
                  control={methods.control}
                  defaultValue={false}
                  render={({ field: { onChange, value } }) => (
                    <input
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        dates.map(({ nameDate, persianDayOfWeek }) => {
                          if (persianDayOfWeek == "جمعه") {
                            methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                            onChange(e.target.checked);
                          }
                        });
                      }}
                      style={{ margin: "0 5px" }}
                    />
                  )}
                />
              جمعه
            </div>
            </Col>
          </Row>
          <Row className="py-4  border rounded-3">
            <Col xs="12" className="pb-3 mb-3 border-bottom">
              <Controller
                name={`CopyTo-CheckedAll`}
                control={methods.control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => {
                      dates.map(({ nameDate }) => {
                        methods.setValue(`CopyTo-${nameDate}`, e.target.checked);
                        onChange(e.target.checked);
                      });
                    }}
                    style={{ margin: "0 5px" }}
                  />
                )}
              />
            انتخاب همه روزها
          </Col>
            {dates.map((date, index) => {
              return (
                <Col key={index} xs="12" sm="6" md="4" lg="3" className="py-2">
                  <Controller
                    name={`CopyTo-${date.nameDate}`}
                    control={methods.control}
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                      <input type="checkbox" checked={value} onChange={onChange} style={{ margin: "0 5px" }} />
                    )}
                  />
                  {date.formattedDate + " " + date.persianDayOfWeek}
                </Col>
              );
            })}
          </Row>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          type="button"
          onClick={(e) => {
            setReserveFormCopyModal({ ...reserveFormCopyModal, isShow: false });
          }}
        >
          <CloseIcon />
        بستن
      </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default memo(CopyDescription)
